import {
  EquipmentPerformance,
  EquipmentPerformanceDto,
  KpiResult,
  KpiResultDto
} from '@hconnect/common/types'
import moment from 'moment-timezone'

const mapKpiResultDto = (dto: KpiResultDto, timezone: string): KpiResult => ({
  ...dto,
  startTime: moment(dto.startTime).tz(timezone),
  endTime: moment(dto.endTime).tz(timezone)
})

const mapRecordValues = <K extends string, V, R>(
  record: Record<K, V>,
  mapFn: (value: V) => R
): Record<K, R> => {
  const result: Partial<Record<K, R>> = {}
  for (const key in record) {
    result[key] = mapFn(record[key])
  }
  return result as Record<K, R>
}

export const mapEquipmentPerformances = (
  data: EquipmentPerformanceDto[],
  timezone: string
): EquipmentPerformance[] =>
  data.map((item) => ({
    ...item,
    kpiPerformance: item.kpiPerformance && {
      kpiAssignments:
        item.kpiPerformance.kpiAssignments &&
        item.kpiPerformance.kpiAssignments.map(({result, timeFrameResults, ...rest}) => ({
          ...rest,
          result: result && mapKpiResultDto(result, timezone),
          timeFrameResults:
            timeFrameResults &&
            mapRecordValues(timeFrameResults, (value) => mapKpiResultDto(value, timezone))
        }))
    }
  }))
